let canvasTools = ['paintBrush', 'eraser'];

const state = {
  canvas: {},
  tool: canvasTools[0],
};

const mutations = {
  SET_CANVAS(state, data) {
    state.canvas = data;
  },
  CHANGE_CANVAS_TOOLL(state, tool) {
    state.tool = tool;
  },
};

const actions = {};

const getters = {
  tool: (state) => {
    return state.tool;
  },
  canvas: (state) => {
    return state.canvas;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
